module.exports = __webpack_public_path__ + "static/media/solarPannelExplore.ce809372.png";